var $3943b517e8cd14e3$exports = {};
const $3943b517e8cd14e3$var$increase = document.querySelector(".sun__increase");
const $3943b517e8cd14e3$var$decrease = document.querySelector(".sun__decrease");
const $3943b517e8cd14e3$var$temperature = document.querySelector(".sun__celcius--number");
const $3943b517e8cd14e3$var$wheather = document.querySelector(".sun__celcius--wheader");
const $3943b517e8cd14e3$var$arrow = document.querySelector(".sun__arrow");
const $3943b517e8cd14e3$var$sunPoints = document.querySelectorAll(".sun__point");
//sun elements
const $3943b517e8cd14e3$var$deg0 = document.querySelector(".deg0");
const $3943b517e8cd14e3$var$deg15 = document.querySelector(".deg15");
const $3943b517e8cd14e3$var$deg30 = document.querySelector(".deg30");
const $3943b517e8cd14e3$var$deg150 = document.querySelector(".deg150");
const $3943b517e8cd14e3$var$deg165 = document.querySelector(".deg165");
const $3943b517e8cd14e3$var$deg180 = document.querySelector(".deg180");
const $3943b517e8cd14e3$var$deg195 = document.querySelector(".deg195");
const $3943b517e8cd14e3$var$deg210 = document.querySelector(".deg210");
const $3943b517e8cd14e3$var$deg225 = document.querySelector(".deg225");
const $3943b517e8cd14e3$var$deg240 = document.querySelector(".deg240");
const $3943b517e8cd14e3$var$deg255 = document.querySelector(".deg255");
const $3943b517e8cd14e3$var$deg270 = document.querySelector(".deg270");
const $3943b517e8cd14e3$var$deg285 = document.querySelector(".deg285");
const $3943b517e8cd14e3$var$deg300 = document.querySelector(".deg300");
const $3943b517e8cd14e3$var$deg315 = document.querySelector(".deg315");
const $3943b517e8cd14e3$var$deg330 = document.querySelector(".deg330");
const $3943b517e8cd14e3$var$deg345 = document.querySelector(".deg345");
//variables
let $3943b517e8cd14e3$var$counter = 23;
let $3943b517e8cd14e3$var$arrowPosition = 285;
let $3943b517e8cd14e3$var$celciusText = "warm";
$3943b517e8cd14e3$var$increase.addEventListener("click", ()=>{
    $3943b517e8cd14e3$var$counter++;
    $3943b517e8cd14e3$var$arrowPosition = $3943b517e8cd14e3$var$arrowPosition + 15;
    $3943b517e8cd14e3$var$displayTemerature();
    $3943b517e8cd14e3$var$blockButton();
    $3943b517e8cd14e3$var$checkSun();
});
$3943b517e8cd14e3$var$decrease.addEventListener("click", ()=>{
    $3943b517e8cd14e3$var$counter--;
    $3943b517e8cd14e3$var$arrowPosition = $3943b517e8cd14e3$var$arrowPosition - 15;
    $3943b517e8cd14e3$var$displayTemerature();
    $3943b517e8cd14e3$var$blockButton();
    $3943b517e8cd14e3$var$checkSun();
});
function $3943b517e8cd14e3$var$displayTemerature() {
    $3943b517e8cd14e3$var$temperature.innerHTML = `${$3943b517e8cd14e3$var$counter}\xb0C `;
    $3943b517e8cd14e3$var$counter > 19 ? $3943b517e8cd14e3$var$celciusText = "warm" : $3943b517e8cd14e3$var$celciusText = "cool";
    $3943b517e8cd14e3$var$wheather.innerHTML = $3943b517e8cd14e3$var$celciusText;
    $3943b517e8cd14e3$var$arrow.style.transform = `rotate(${$3943b517e8cd14e3$var$arrowPosition}deg) translate(100px) rotate(90deg)`;
}
function $3943b517e8cd14e3$var$blockButton() {
    if ($3943b517e8cd14e3$var$counter >= 30) $3943b517e8cd14e3$var$increase.disabled = true;
    else $3943b517e8cd14e3$var$increase.disabled = false;
    if ($3943b517e8cd14e3$var$counter <= 14) $3943b517e8cd14e3$var$decrease.disabled = true;
    else $3943b517e8cd14e3$var$decrease.disabled = false;
}
function $3943b517e8cd14e3$var$checkSun() {
    $3943b517e8cd14e3$var$sunPoints.forEach((point)=>{
        if (point.dataset.temp <= $3943b517e8cd14e3$var$counter) point.style.backgroundColor = "#328291";
        else point.style.backgroundColor = "#fff";
    });
}
$3943b517e8cd14e3$var$checkSun();


//# sourceMappingURL=uncommon.6e2f63a7.js.map
